"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/NotificationBellChecked` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const NotificationBellChecked = createSVGIcon(
  <>
    <path
      d="M9.171 20.133a2.71 2.71 0 0 0 2.622 2.028 2.71 2.71 0 0 0 2.622-2.028M19.179 9.308c0 8.11 2.85 8.327 3.621 8.327H1.5c.786 0 3.621-.235 3.621-8.327 0-1.934.74-3.79 2.059-5.157a6.9 6.9 0 0 1 4.97-2.136c1.18 0 2.33.308 3.35.882"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m13.417 6.125 2.143 1.827a.6.6 0 0 0 .182.178.46.46 0 0 0 .46.009.56.56 0 0 0 .187-.172l3.934-5.986"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "NotificationBellChecked",
  (strictLocalize) => ({
    color: Core.icon.default,
    fill: "none",
    titleAccess: strictLocalize({
      id: "duJszp",
      defaultMessage: "Notification set",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
    className: legacyIconCls(),
  })
);
